import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_resourceId', ['fkTriggerGroupId', 'resourceId', 'fkTriggerId'], {})
@Index('_resourceId_2', ['deletedUserId', 'resourceId'], {})
@Index('_resourceId_3', ['fkTriggerGroupId', 'resourceId', 'fkObjectId'], {
	unique: true,
})
@Index('_trigger_group_state__fk__trigger__id_fk', ['fkTriggerId'], {})
@Index(
	'_trigger_group_state__fk__trigger_group__id_fk',
	['fkTriggerGroupId'],
	{},
)
@Entity('_trigger_group_state')
export class TriggerGroupStateEntity extends BaseEntity {
	@Column('int', { name: '_fk__trigger_group__id', unsigned: true })
	public fkTriggerGroupId!: number;

	@Column('int', { name: '_resourceId', unsigned: true })
	public resourceId!: number;

	@Column('int', { name: '_fk__trigger__id', nullable: true, unsigned: true })
	public fkTriggerId!: number | null;

	@Column('int', { name: '_totalIterations', default: () => "'0'" })
	public totalIterations!: number;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('varchar', { name: '_result', nullable: true, length: 255 })
	public result!: string | null;

	@Column('int', {
		name: '_totalIterationsSinceDuration',
		default: () => "'0'",
	})
	public totalIterationsSinceDuration!: number;
}
